import React from 'react';
import "../Hero/Hero.css"
import { Container, Row, Col, Button } from 'react-bootstrap';
import Hero from '../../assets/Home/Hero.png';

const HeroSection = () => {

  // Smooth scroll function for the Hero button
  const scrollToProducts = (e) => {
    e.preventDefault();
    const element = document.getElementById('products');
    if (element) {
      const offset = 80; // Matches your navbar height
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="pt-5 pb-5 heroSection" id='home'>
      <Container>
        <Row className="align-items-start">
          
          <Col lg={7} md={12}>
            <span className="hero-label">Precision Manufacturing</span>
            <h1 className="hero-heading">
              Engineering <span className="text-highlight">Precision</span><br />
              Not Just Components
            </h1>
          </Col>

          <Col lg={5} md={12} className="hero-desc-col d-flex flex-column justify-content-center align-items-end ps-lg-5">
            <p className="hero-desc">
              ISO-certified manufacturer specializing in precision stamping 
              and engineered auto components for OEMs and Tier-1 suppliers, 
              with a strong focus on quality and on-time delivery.
            </p>
            
            {/* Added the onClick handler here */}
            <Button className="btn-orange-pill" onClick={scrollToProducts}>
              View Products 
            </Button>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div className="hero-image-container">
              <img 
                src={Hero}
                alt="Industrial Lathe Machine" 
                className="hero-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;